import { Avatar, Flex, Menu, Portal, Text } from '@chakra-ui/react';
import CreateOrgMenuItem from '@features/navigation/CreateOrgMenuItem';
import { toPxString } from 'helpers/styles';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { HiChevronUpDown } from 'react-icons/hi2';
import { useOrgStore } from 'stores/rootStore';

const ORG_PICKER_MAX_WIDTH_PX = 300;
const OrgPicker = () => {
  const { orgs, selectedOrg } = useOrgStore();

  const handleOrgChange = useCallback(
    (orgId: string) => () => {
      const org = orgs.find((o) => o.id === orgId);
      if (org != null && org.id !== selectedOrg?.id) {
        window.location.href = `/${org.slug}`;
      }
    },
    [orgs, selectedOrg],
  );

  return (
    <Menu.Root positioning={{ placement: 'bottom-start' }}>
      <Menu.Trigger asChild>
        <Flex cursor="pointer" alignItems="center" gap={2} w="full">
          <Avatar.Root size="xs">
            <Avatar.Fallback name={selectedOrg?.name} />
          </Avatar.Root>
          <Flex flexDirection="column" w="full">
            <Text color="text.secondary" fontWeight="medium" textAlign="left" fontSize="xs">
              Business
            </Text>
            <Text fontWeight="medium" textAlign="left" fontSize="sm">
              {selectedOrg?.name}
            </Text>
          </Flex>
          <HiChevronUpDown size="24px" />
        </Flex>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner w={toPxString(ORG_PICKER_MAX_WIDTH_PX)}>
          <Menu.Content bgColor="surface.background" p={2} fontWeight="medium" borderRadius="lg">
            <Text fontSize="sm" color="text.secondary" mb={2}>
              Businesses
            </Text>
            {orgs.map((org) => (
              <Menu.CheckboxItem
                key={org.id}
                value={org.id}
                checked={selectedOrg?.id === org.id}
                onCheckedChange={handleOrgChange(org.id)}
                cursor="pointer"
                fontSize="sm"
                _highlighted={{ bg: 'surface.hover' }}
                borderRadius="md"
              >
                {org.name}
                <Menu.ItemIndicator color="selection.500" />
              </Menu.CheckboxItem>
            ))}
            <Menu.Separator borderColor="border.light" />
            <CreateOrgMenuItem />
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};

export default observer(OrgPicker);
